import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-148" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-149" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-[1.15rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.75rem]" data-id="element-150" data-mp="3fy2z7vpm7s3i">
          What ultrasound students are saying
        </h2>
        <div className="mt-2 space-y-2" data-id="element-151" data-mp="3700rkxbdm179">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 bg-clinical px-2.5 py-2" data-id="element-152" data-mp="31zd3ajej7ygq">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-153" data-mp="2x1bh3plt7j11">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-154" data-mp="v96jbxhmprie" data-mpi={i} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] leading-[1.4] sm:text-[0.9rem]" data-id="element-155" data-mp="qbeuxdg70niy">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-156" data-mp="h8aytf4m6trr">
                <span className="font-extrabold text-navy" data-id="element-157" data-mp="m2yceiy2y3rk">{t.name}</span>
                <span className="text-charcoal/75" data-id="element-158" data-mp="79258ndnvh5x">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}